import { FC, useEffect, useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Option from "./Option";
import { useStore, connect } from 'src/store/connect';
interface OptionsProps {
  targetBlock: Block;
  onChangeOptionIncomingMessage: (id: string, newIncomingMessage: string) => void;
};

const Options: FC<OptionsProps> = ({ targetBlock }) => {
    const classes = useStyles();

    const state = useStore();
    const [targets, setTargets] = useState<NodeReactFlow[]>([])

    useEffect(() => {
      const sourceTargets = state.getTargets(targetBlock.id)
      if (!sourceTargets || sourceTargets.length === 0) {
        return
      }
      setTargets(sourceTargets)
    }, [state.flow, state.flow.edges, state.flow.nodes]);

    const onRemoveOptionBlock = (id: string) => {
      state.removeBlock(id)
    }

    const onChangeOptionIncomingMessage = (id: string, newIncomingMessage: string) => {
      const currentData = state.getBlock(id)?.data
      if (!currentData) {
        return
      }
      state.updateBlock(id, {
        ...currentData,
        incomingMessage: newIncomingMessage,
      })
    }

    return (
      <div className={classes.root}>
        {targets.map((node) => {
          return (
            <Option
              block={node}
              onChangeOptionIncomingMessage={onChangeOptionIncomingMessage}
              onRemoveOption={onRemoveOptionBlock}
              key={`option-${node.id}`} />
          );
        })}
      </div>
    );
};

Options.defaultProps = { };

export default connect(Options);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
  },
}));
